import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'lifedi-btn',
  templateUrl: './btn-life-di.component.html',
  styleUrls: ['./btn-life-di.component.scss']
})
export class BtnLifeDiComponent implements OnInit {
  @Input() lable: string;
  @Input() customStyle: string;
  @Input() color: string;
  @Input() disabled: boolean;
  @Output() onClick = new EventEmitter();
  constructor() { }

  ngOnInit() { }

}
